// Тема: светлая / тёмная / как в системе (до отрисовки её ставит скрипт в index.html)
import { store } from '../shared/lib/storage';
import { createStore, useStore } from '../shared/lib/store';

export const isDark = (): boolean => {
  const t = document.documentElement.dataset.theme;
  return t === 'dark' || (!t && typeof matchMedia === 'function' && matchMedia('(prefers-color-scheme: dark)').matches);
};

const themeStore = createStore({ dark: typeof document !== 'undefined' ? isDark() : false });
export const useThemeDark = (): boolean => useStore(themeStore, (s) => s.dark);

export function applyTheme(theme: 'light' | 'dark' | null): void {
  if (theme) document.documentElement.dataset.theme = theme;
  else delete document.documentElement.dataset.theme;
  themeStore.set({ dark: isDark() });
}

export function toggleTheme(): void {
  const next = isDark() ? 'light' : 'dark';
  store.set('theme', next);
  applyTheme(next);
}

/** При старте: сохранённая тема */
export const initTheme = (): void => applyTheme(store.get<'light' | 'dark' | null>('theme', null));
